import type { CurrencyCode, TariffPrice } from "@/services/api/entities/payment/types";

const formatters: Record<CurrencyCode, Intl.NumberFormat> = {
  RUB: new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "RUB",
    maximumFractionDigits: 2,
  }),
  USD: new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }),
  AED: new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "AED",
    maximumFractionDigits: 2,
  }),
};

export const priceFormat = ({ amount, currencyCode }: TariffPrice) => {
  const numPrice = parseFloat(amount);
  if (isNaN(numPrice)) return amount;

  const formatter = formatters[currencyCode] ?? formatters.RUB;
  const formattedPrice = formatter.format(numPrice);

  return formattedPrice.replace(/([.,]00)$/, "");
};
